import { useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { fehlerText, WOCHENTAGE } from './api';

/* „So sieht es der Kunde“: die Woche in der Form der App (Tage in Reihenfolge, Tagestyp, Übungen mit Rolle, Vorgabe
   und Hinweis). Der Server baut die Vorschau (trainingsplaner.logik.kunden_vorschau) — Trainer-Notizen fehlen dort
   wie in der App. */

export default function Vorschau({ api, zid, woche, version }) {
  const [v, setV] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    let aktiv = true;
    api.vorschau(zid, woche).then((r) => { if (aktiv) { setV(r.data); setErr(''); } })
      .catch((e) => { if (aktiv) setErr(fehlerText(e, 'Vorschau nicht geladen')); });
    return () => { aktiv = false; };
  }, [api, zid, woche, version]);
  if (err) return <p className="text-sm text-destructive" role="alert">{err}</p>;
  if (!v) return <Skeleton className="h-96 w-[320px]" />;
  return (
    <div className="mx-auto w-full max-w-[340px] rounded-[32px] border-[6px] border-foreground/80 bg-background p-3 shadow-xl" data-testid="plan-vorschau">
      <div className="mb-2 flex items-center justify-between px-1">
        <p className="text-xs font-bold">Training</p>
        <p className="text-[11px] text-muted-foreground">Woche {v.woche} · {v.phase}{v.typ === 'deload' ? ' · Entlastung' : ''}</p>
      </div>
      <p className="mb-2 px-1 text-[11px] text-muted-foreground">
        {v.tage_ablauf === 'kunde_waehlt' ? 'Du wählst den Tag.' : 'Tage der Reihe nach.'} {v.uebungs_ablauf === 'frei' ? 'Übungen in freier Reihenfolge.' : 'Übungen in dieser Reihenfolge.'}
      </p>
      <div className="max-h-[60vh] space-y-2 overflow-y-auto">
        {v.tage.map((t) => (
          <div key={t.key} className="rounded-[16px] border border-border bg-card p-3">
            <div className="flex items-center justify-between gap-2">
              <p className="text-sm font-extrabold">{t.titel}</p>
              <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${t.tagestyp === 'restday' ? 'bg-muted text-muted-foreground' : 'bg-marke text-white'}`}>{t.tagestyp_label}</span>
            </div>
            {t.wochentage?.length > 0 && <p className="text-[11px] text-muted-foreground">{t.wochentage.map((d) => WOCHENTAGE[d]).join(' · ')}</p>}
            {t.tagestyp === 'restday' ? <p className="mt-1 text-xs text-muted-foreground">Ruhetag – erhol dich gut.</p> : (
              <ul className="mt-2 space-y-1.5">
                {t.uebungen.map((u, i) => (
                  <li key={`${u.name}-${i}`} className="rounded-[10px] bg-muted/50 px-2 py-1.5">
                    <p className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">{u.rolle}</p>
                    <p className="text-sm font-semibold">{u.name}</p>
                    {u.vorgabe && <p className="text-xs text-muted-foreground">{u.vorgabe}</p>}
                    {u.hinweis && <p className="text-xs italic text-muted-foreground">{u.hinweis}</p>}
                  </li>
                ))}
                {!t.uebungen.length && <li className="text-xs text-muted-foreground">Noch nichts geplant.</li>}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
